import React from 'react';
import { useSelector } from 'react-redux';
import { isNullOrUndefined } from 'util';
import Badge from 'react-bootstrap/Badge'

const NotificationBadge = ({ mobile }) => {
    //Redux store data
    const newNotifCount = useSelector(state => state.auth.newNotifCount);

    if(isNullOrUndefined(newNotifCount) || 0 === newNotifCount){
        return ""
    }
    
    return (
        <Badge 
            pill 
            variant="danger" 
            style={mobile ? { position: 'absolute', marginLeft: 20, marginTop: -24 }
            : { position: 'absolute', marginLeft: 100, marginTop: -21 }}
        >
            {newNotifCount}
        </Badge>
    );
};

export default NotificationBadge;